import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'default' | 'neu';
}

export const Input: React.FC<InputProps> = ({ 
  className = '', 
  variant = 'default',
  ...props 
}) => {
  const baseClasses = variant === 'neu' ? 'input-neu' : 'input';

  return (
    <input 
      className={`${baseClasses} ${className}`} 
      {...props}
    />
  );
};
